
<template>
  <div class="body">
     
  </div>
</template>
  <script>
    import { Dialog } from "vant";
    import { wxRequest } from "@/api/user.js";
    export default {
      data() {
        return {
     
        };
      },
      mounted() {
        wxRequest("applyChangeSim/select/haoka/url", {}, "post").then((res) => {
            if (res.data.code === "200") {
              window.location.href =res.data.data;
            } else {
              Dialog.alert({ title: "提示", message: res.data.message });
            }
          })
      },
      methods: {
   
      },
    };
  </script>
